<template>
	<div v-if="show" :class="slideInClass">
		<header :class="{'titled': hasTitle}">
			<div v-if="hasTitle">
				<h1>{{ title }}</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan(false)">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<h3 v-if="subTitle">{{ subTitle }}</h3>
			<Item
				v-for="item in items"
				:key="item.item.id"
				:item="item"
			/>
			<div v-if="type === 'application'">
				<NoExperienceInfo />
			</div>
		</main>
		<footer>
			<Button
				text="OK"
				:disabled="!valid"
				icon="checkmark"
				@click="closeFan(true)"
			/>
		</footer>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {mapActions, mapGetters, mapState} from "vuex";
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/characteristic/addition/matrix/fan";
import Item from "./Item";
import NoExperienceInfo from "@/vue/application/characteristic/NoExperienceInfo.vue";
import {isEmptyOrNull} from "@/helper/String";

export default {

	components: {
		NoExperienceInfo,
		Button,
		Icon,
		Item,
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('characteristic/addition/matrix/fan', [
			'show',
			'title',
			'subTitle',
			'type',
			'items',
			'experienceConfig',
			'selfAssessmentConfig',
			'educationConfig'
		]),
		...mapState('layout', ['fanLevelClasses']),
		...mapGetters('characteristic/addition/matrix/fan', [
			'withExperience',
			'withEducation',
			'withSelfAssessment'
		]),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in', 'characteristic-addition-matrix-fan']
			});
		},
		hasTitle ()
		{
			return this.title && !isEmptyOrNull(this.title);
		},
		validItems ()
		{
			return _.filter(this.items, item => this.isValid(item));
		},
		valid ()
		{
			return this.validItems.length === this.items.length;
		},
	},

	methods: {
		...mapActions('characteristic/addition/matrix/fan', [
			'close',
		]),
		isValid (item)
		{
			let valid = true;

			if (this.withExperience)
			{
				valid = valid && item.experience !== undefined;
			}

			if (this.withSelfAssessment)
			{
				valid = valid && item.selfAssessment !== undefined;
			}

			if (this.withEducation)
			{
				valid = valid && item.educationsFinished !== undefined && item.educationsUnfinished !== undefined;
			}

			return valid;
		},
		closeFan (confirmed)
		{
			this.close({
				confirmed,
				items: this.items
			});
		},
	},
}
</script>
